<template>
    <button class="cz2__two_pack_selector__button">
        <div class="cz2__two_pack_selector__button-content">
            <rounded-banner
                :banner-copy="bannerCopy"
                :banner-color="bannerColor"
            />

            <h2 class="cz2__two_pack_selector__button-heading">
                {{ headingCopy }}
            </h2>

            <p class="cz2__two_pack_selector__button-copy">
                {{ contentCopy }}
            </p>

            <p
                class="cz2__two_pack_selector__button-copy cz2__two_pack_selector__button-price"
                v-html="priceCopy"
            />

            <btn
                v-if="isKiosk || isCalendar"
                as="span"
                class="cz2__btn--narrow cz2__btn--secondary"
            >
                <span>
                    {{ ctaCopy }}
                </span>
            </btn>
        </div>

        <div
            :style="{
                backgroundImage: `url(${packImage})`,
            }"
            aria-hidden="true"
            class="cz2__two_pack_selector__content__image-container"
        />

        <btn
            v-if="!isKiosk && !isCalendar"
            as="span"
            class="cz2__btn--narrow cz2__btn--secondary"
        >
            <span>
                {{ ctaCopy }}
            </span>
        </btn>
    </button>
</template>

<script>
    import RoundedBanner from './ui/RoundedBanner.vue';
    import Btn from './ui/Btn.vue';

    export default {
        name: 'TwoPackSelectorCard',

        components: {
            RoundedBanner,
            Btn,
        },

        props: {
            packImage: {
                type: String,
                default: '',
            },

            bannerCopy: {
                type: String,
                default: '',
            },

            bannerColor: {
                type: String,
                default: '',
            },

            headingCopy: {
                type: String,
                default: '',
            },

            contentCopy: {
                type: String,
                default: '',
            },

            priceCopy: {
                type: String,
                default: '',
            },

            ctaCopy: {
                type: String,
                default: '',
            },

            isCalendar: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },
    };
</script>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__two_pack_selector__button {
            position: relative;

            border-radius: 48px;
            padding: 24px;
            background: white;

            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: start;
            text-align: left;

            width: 100%;
            height: 100%;

            .cz2__two_pack_selector__button-content {
                display: flex;
                flex-direction: column;
            }

            .cz2__two_pack_selector__button-heading {
                font-family: Proxima Nova;
                font-weight: 900;
                font-style: italic;
                font-size: 20px;
                line-height: 25px;
                letter-spacing: 0px;
                text-transform: uppercase;
                color: black !important;
            }

            .cz2__two_pack_selector__button-copy {
                font-size: 15px;
                line-height: 19px;
                color: #707070;
            }

            .cz2__two_pack_selector__button-price {
                margin-top: 8px;
                line-height: 21px;
            }

            .cz2__btn--secondary {
                margin-top: 8px;

                width: 100%;
                height: 40px;

                background-color: #0874E4;
                color: white;
                font-size: 14px;
                font-weight: 800;

                &.cz2__btn--narrow:hover,
                &:hover {
                    font-size: 14px;
                }
            }

            &:focus-visible {
                outline: none;
                border: 2px solid #1E5A99;
            }
        }

        .cz2__two_pack_selector__content__image-container {
            // margin-bottom: 12px;
            height: 221px;
            width: 100%;

            background-color: transparent;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
        }

        @include respond-above(lg) {
            .cz2__two_pack_selector__button-li {
                padding: 0;
            }

            .cz2__two_pack_selector__button {
                padding: 24px 32px;
                // width: 452px;

                .cz2__btn--secondary {
                    background-color: #EDEDED;
                    color: black;

                    &.cz2__btn--narrow:hover,
                    &:hover {
                        background-color: #0874E4;
                        color: white;
                    }
                }
            }

            .cz2__two_pack_selector__button-heading {
                margin-bottom: 8px;
                font-size: 22px;
                line-height: 26px;
            }

            .cz2__two_pack_selector__content__image-container {
                // margin-bottom: 24px;
                height: 217px;
            }
        }

        @include respond-above(md) {
            .cz2__two_pack_selector__button {
                // width: 452px;
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__two_pack_selector__button {
            flex-direction: row;
            gap: 40px;

            .cz2__rounded-banner {
                font-size: 20px;
                line-height: 44px;
                height: 32px;
                padding-right: 12px;
            }

            .cz2__two_pack_selector__content__image-container {
                order: -1;
                width: 48%;
                height: 100%;
            }

            .cz2__two_pack_selector__button-content {
                flex: 1;
                height: 100%;
                justify-content: center;
            }

            .cz2__two_pack_selector__button-heading {
                font-size: 24px;
            }

            .cz2__two_pack_selector__button-copy {
                font-size: 16px;
            }

            .cz2__btn--secondary {
                align-self: start;
                width: auto;
                height: 48px;
                padding: 6px 32px;
                font-size: 18px;
                background-color: #0874E4;
                color: white;

                &.cz2__btn--narrow:hover {
                    font-size: 18px;
                }
            }
        }
    }
</style>
